import { Container, makeStyles, Theme, Typography } from '@material-ui/core';
import React, { FC } from 'react';

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      margin: theme.spacing(9, 0, 8),
    },
    subTitle: {
      margin: theme.spacing(5, 0),
    },
    text: {
      marginBottom: theme.spacing(5),
    },
    link: {
      color: theme.palette.primary.main,
      margin: theme.spacing(0, 1),
      fontStyle: 'italic',
    },
    list: {
      margin: theme.spacing(7, 0),
      paddingLeft: theme.spacing(5),
      listStyle: 'circle',
      [theme.breakpoints.up('md')]: {
        textAlign: 'justify',
        paddingLeft: theme.spacing(10),
      },
    },
    listItem: {
      margin: theme.spacing(1, 0),
    },
  };
});

const TermsOfUse: FC = () => {
  const classes = useStyles();
  return (
    <Container maxWidth={false} fixed>
      <Typography className={classes.title} variant="h1">
        <span>Terms and Conditions</span>
      </Typography>

      <Typography className={classes.text}>
        Welcome
        <USSoftwareLink />
      </Typography>

      <Typography className={classes.text}>
        These terms and conditions outline the rules and regulations for the use of US Software Solutions’ Website, located at
        <USSoftwareLink />.
      </Typography>

      <Typography className={classes.text}>
        By accessing this Website, we assume you accept these terms and conditions. Do not continue to use US Software Solutions
        if you do not agree to accept all of the terms and conditions stated on this page.
      </Typography>

      <Typography className={classes.text}>
        The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all
        Agreements: "Client," "You," and "Your" refers to you, the person log on this Website and compliant to the Company's terms
        and conditions. "The Company," "Ourselves," "We," "Our," and "Us" refers to our Company. "Party," "Parties," or "Us"
        refers to both the Client and ourselves. All terms refer to the offer, acceptance, and consideration of payment necessary
        to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting
        the Client's needs in respect of the provision of the Company's stated services, following and subject to, prevailing law
        of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization, and/or he/she are
        taken as interchangeable and, therefore, referring to the same.
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>Cookies</span>
      </Typography>

      <Typography className={classes.text}>
        We employ the use of cookies. By accessing US Software Solutions, you agreed to use cookies in agreement with the US
        Software Solutions’ Privacy Policy.
      </Typography>

      <Typography className={classes.text}>
        Most interactive websites use cookies to let us retrieve the user's details for each visit. Our Website uses cookies to
        enable the functionality of certain areas to make it easier for people visiting our Website. Some of our
        affiliate/advertising partners may also use cookies.
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>License</span>
      </Typography>

      <Typography className={classes.text}>
        Unless otherwise stated, US Software Solutions and/or its licensors own the intellectual property rights for all material
        on US Software Solutions. All intellectual property rights are reserved. You may access this from US Software Solutions
        for your personal use, subjected to restrictions set in these terms and conditions.
      </Typography>

      <Typography className={classes.text}>You must not:</Typography>
      <Typography component="ul" className={classes.list}>
        <Typography component="li" className={classes.listItem}>
          Republish material from US Software Solutions
        </Typography>
        <Typography component="li" className={classes.listItem}>
          Sell, rent, or sub-license material from US Software Solutions
        </Typography>
        <Typography component="li" className={classes.listItem}>
          Reproduce, duplicate, or copy material from US Software Solutions
        </Typography>
        <Typography component="li" className={classes.listItem}>
          Redistribute content from US Software Solutions
        </Typography>
        <Typography component="li" className={classes.listItem}>
          This Agreement shall begin on the date hereof
        </Typography>
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>Hyperlinking to our Content</span>
      </Typography>

      <Typography className={classes.text}>
        The following organizations may link to our Website without prior written approval:
      </Typography>

      <Typography component="ul" className={classes.list}>
        <Typography component="li" className={classes.listItem}>
          Government agencies;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          Search engines;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          News organizations;
        </Typography>
      </Typography>

      <Typography className={classes.text}>
        Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed
        businesses; Systemwide Accredited Businesses, except soliciting non-profit organizations, charity shopping malls, and
        charity fundraising groups, may not hyperlink to our Website.
      </Typography>

      <Typography className={classes.text}>
        These organizations may link to our home page, to publications, or other Website information so long as the link: (a) is
        not in any way deceptive; (b) does not falsely imply sponsorship, endorsement, or approval of the linking party and its
        products and/or services; and (c) fits within the context of the linking party's site.
      </Typography>

      <Typography className={classes.text}>
        We may consider and approve other link requests from the following types of organizations:
      </Typography>

      <Typography component="ul" className={classes.list}>
        <Typography component="li" className={classes.listItem}>
          commonly-known consumer and/or business information sources;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          dot.com community sites;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          associations or other groups representing charities;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          online directory distributors;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          internet portals;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          internet portals;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          accounting, law and consulting firms; and
        </Typography>
        <Typography component="li" className={classes.listItem}>
          educational institutions and trade associations.
        </Typography>
      </Typography>

      <Typography className={classes.text}>
        We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably
        to ourselves or our accredited businesses; (b) the organization does not have any negative records with us; (c) the
        benefit to us from the visibility of the hyperlink compensates the absence of US Software Solutions, and (d) the link is
        in the context of general resource information.
      </Typography>

      <Typography className={classes.text}>
        These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely
        imply sponsorship, endorsement, or approval of the linking party and its products or services; and (c) fits within the
        context of the linking party's site.
      </Typography>

      <Typography className={classes.text}>
        If you are one of the organizations listed above and are interested in linking to our Website, you must inform us by
        sending an email to US Software Solutions. Please include your name, your organization name, contact information as well
        as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our
        site to which you would like to link. Wait 2-3 weeks for a response.
      </Typography>

      <Typography className={classes.text}>Approved organizations may hyperlink to our Website as follows:</Typography>

      <Typography component="ul" className={classes.list}>
        <Typography component="li" className={classes.listItem}>
          By use of our corporate name; or
        </Typography>
        <Typography component="li" className={classes.listItem}>
          By use of the uniform resource locator being linked to; or
        </Typography>
        <Typography component="li" className={classes.listItem}>
          By use of any other description of our Website being linked to that makes sense within the context and format of content
          on the linking party's site.
        </Typography>
        <Typography component="li" className={classes.listItem}>
          No use of US Software Solutions’ logo or other artwork will be allowed for linking absent a trademark license agreement.
        </Typography>
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>iFrames</span>
      </Typography>

      <Typography className={classes.text}>
        Without prior approval and written permission, you may not create frames around our Web Pages that alter in any way the
        visual presentation or appearance of our Website.
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>Content Liability</span>
      </Typography>

      <Typography className={classes.text}>
        We shall not be held responsible for any content that appears on our Website. No link(s) should appear on any Website that
        may be interpreted as libelous, obscene, or criminal, or which infringes, otherwise violates, or advocates the
        infringement or other violation of, any third party rights.
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>Reservation of Rights</span>
      </Typography>

      <Typography className={classes.text}>
        We reserve the right to request that you remove all links or any particular link to our Website. You approve of removing
        all links to our Website upon request immediately. We also reserve the right to amend these terms and conditions and its
        linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking
        terms and conditions.
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>Removal of links from our Website</span>
      </Typography>

      <Typography className={classes.text}>
        If you find any link on our Website that is offensive for any reason, you are free to contact and inform us at any moment.
        We will consider requests to remove links, but we are not obliged to respond to you directly.
      </Typography>

      <Typography className={classes.text}>
        We do not ensure that the information on this Website is correct. We do not warrant its completeness or accuracy, nor do
        we promise to ensure that the Website remains available or that the web site's material is kept up to date.
      </Typography>

      <Typography className={classes.subTitle} variant="h2">
        <span>Disclaimer</span>
      </Typography>

      <Typography className={classes.text}>
        To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to
        our Website and the use of this Website. Nothing in this disclaimer will:
      </Typography>

      <Typography component="ul" className={classes.list}>
        <Typography component="li" className={classes.listItem}>
          limit or exclude our or your liability for death or personal injury;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          limit or exclude our or your liability for fraud or fraudulent misrepresentation;
        </Typography>
        <Typography component="li" className={classes.listItem}>
          modify any of our or your liabilities in any way that is not permitted under applicable law; or
        </Typography>
        <Typography component="li" className={classes.listItem}>
          exclude any of our or your liabilities that may not be excluded under applicable law.
        </Typography>
      </Typography>

      <Typography className={classes.text}>
        The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the
        preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in
        contract, in tort, and for breach of statutory duty.
      </Typography>

      <Typography className={classes.text}>
        As long as the Website and the information and services on the Website are provided free of charge, we will not be liable
        for any loss or damage of any nature.
      </Typography>
    </Container>
  );
};

const USSoftwareLink: FC = () => {
  const classes = useStyles();
  return (
    <Typography component="span" className={classes.link}>
      ussoftwaresolutions.us
    </Typography>
  );
};

export default TermsOfUse;
